import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { HydraCollection } from '../hydra/hydra-collection';

@Injectable({
  providedIn: 'root'
})
export class OrganisationProfileAttachmentApiService extends ApiService {
  readonly resourcePath = 'organisation_profile_attachments';


  create(body:any){
    return this.restCreate(body);
  }

  list(filters: Record<string, string> = {}): Observable<HydraCollection<any>> {
    return this.restList<any>(filters);
  }

  get(id: string): Observable<any> {
    return this.restRead<any>(id);
  }

  update(id:string, body:any){
    return this.restUpdate(id, body);
  }

  delete(id:string){
    return this.restDelete(id);
  }
}
